import React, { Component } from 'react';
import { Box, DataBox, DataWrapperClass, Row, RowTitle } from '../styles';
import { Wrapper } from 'modules/layout/components';
import PropTypes from 'prop-types';
import { Tab, Tabs } from 'react-bootstrap';
import {
  Button,
  ModalTrigger,
  FormGroup,
  ControlLabel,
  FormControl
} from 'modules/common/components';
import { Modal } from 'react-bootstrap';

export class PhoneCalls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      title: '',
      show: false
    };

    this.onChange = this.onChange.bind(this);
    this.dragNdrop = this.dragNdrop.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  dragNdrop(event) {
    var fileName = URL.createObjectURL(event.target.files[0]);
    var preview = document.getElementById('preview');
    var previewImg = document.createElement('img');
    previewImg.setAttribute('src', fileName);
    preview.appendChild(previewImg);
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [{ title: __('Team'), link: '/team' }];
    const content = (
      <div>
        {/* <RowTitle className="secondRow">{__('Test')}</RowTitle> */}
        <Row style={{ marginLeft: '40px', marginBottom: '20px' }}>
          <div className="calls">
            <h5>Getting started with phone calls.</h5>
            <h5>Manage your customer interaction by connecting phone calls.</h5>
            <div style={{ marginTop: '25px', marginBottom: '15px' }}>
              <DataBox>
                <div className="custom_radio">
                  <input type="radio" id="featured-1" name="featured" checked />
                  <label for="featured-1">
                    <div className="lines1"></div>
                    <div className="lines2"></div>
                    <div className="lines3"></div>
                  </label>
                </div>
              </DataBox>
              <DataBox>
                <div className="custom_radio">
                  <input type="radio" id="featured-2" name="featured" />
                  <label for="featured-2">
                    <div className="lines1"></div>
                    <div className="lines2"></div>
                    <div className="lines3"></div>
                  </label>
                </div>
              </DataBox>
              <DataBox>
                <div className="custom_radio">
                  <input type="radio" id="featured-3" name="featured" />
                  <label for="featured-3">
                    <div className="lines1"></div>
                    <div className="lines2"></div>
                    <div className="lines3"></div>
                  </label>
                </div>
              </DataBox>
            </div>
            <Button btnStyle="default" icon="rightarrow" size="medium">
              Connect
            </Button>
            <div style={{ marginTop: '30px' }}>
              <Button
                btnStyle="default"
                size="small"
                icon="add"
                onClick={this.showModal}
              >
                Add
              </Button>

              <Modal
                show={this.state.show}
                handleClose={this.hideModal}
                className="FModal"
              >
                <Modal.Body>
                  <Row>
                    <Tabs
                      defaultActiveKey="uploadfiles"
                      id="uncontrolled-tab-example"
                      className="customTabs"
                    >
                      <Tab eventKey="texttospeech" title="Text to Speech">
                        Hello
                      </Tab>
                      <Tab eventKey="uploadfiles" title="Upload Files">
                        <form>
                          <FormControl
                            type="text"
                            placeholder="Title"
                            value={this.state.title}
                            name="title"
                            required
                            onChange={this.onChange}
                          />
                          <div className="fileI">
                            <div>
                              <img src="/images/file.png" />
                              <span>Select or drop a file to upload.</span>
                              <FormControl
                                type="file"
                                placeholder="file"
                                value={this.state.file}
                                name="file"
                                required
                                onChange={this.dragNdrop}
                              />
                            </div>
                            {/* <div id="preview"></div> */}
                          </div>
                          <div style={{ textAlign: 'end', marginTop: '20px' }}>
                            <Button
                              onClick={this.hideModal}
                              btnStyle="secondary"
                              type="submit"
                              style={{
                                padding: '7px 20px',
                                borderRadius: '25px',
                                marginBottom: '20px',
                                marginRight: '10px'
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              btnStyle="default"
                              type="submit"
                              style={{
                                padding: '7px 20px',
                                borderRadius: '25px',
                                marginBottom: '20px'
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </Tab>
                    </Tabs>
                  </Row>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </Row>
      </div>
    );

    return (
      <DataWrapperClass>
        <Wrapper
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          content={content}
          transparent={true}
        />
      </DataWrapperClass>
    );
  }
}

PhoneCalls.contextTypes = {
  __: PropTypes.func
};

export default PhoneCalls;



// WEBPACK FOOTER //
// src/modules/screens/settings/PhoneCalls/components/PhoneCalls.js